<template>
    <div class="graph-cont-left">
      <span class="center"></span>
      <div class="graph" ref="myEchart" style="height: 380px" />
    </div>
</template>
  <script>
  const echarts = require("echarts");
  export default {
    name: "Graph",
    data() {
      return {
        chart:null,
        self: this,
        activeName: "first",
        mapActiveName: "0",
        mapActiveLabel: "以人民为中心",
        tabActiveName: "0",
        mapData: [],
        list: [],
          data: [
              { value: 10,name: "以人民为中心" },
              { value: 10,name: "全面从严治党" },
              { value: 10,name: "坚持党的全面领导" },
              { value: 10,name: "中国式现代化" },
              { value: 10,name: "推进祖国统一" },
              { value: 10,name: "构建人类命运共同体" },
              { value: 10,name: "国家安全" },
              { value: 10,name: "全面深化改革" },
              { value: 10,name: "国防和军队现代化建设" },
              { value: 10,name: "文化建设" },
              { value: 10,name: "民生福祉" },
              { value: 10,name: "社会治理" },
              { value: 10,name: "依法治国" },
              { value: 10,name: "经济建设" },
              { value: 10,name: "政治建设" },
              { value: 10,name: "绿色发展 " },
              { value: 10,name: "科教兴国" },
              { value: 10,name: "高质量发展" },
          ],
      };
    },
    mounted() {
        this.getGraph();
    },
    beforeDestroy() {
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
    },
    methods: {
        getGraph(){
            this.axios.get(this.url.djUrl+"data/custom/classType?uid=5575c287-9573-4e23-9ada-0df40f56eb18").then((res) => {
                if (res.data.code == 200) {
                    let arr = res.data.rows;
                    this.data = this.data.map((item,i) => {
                        return {
                            ...item,
                            name:arr[i].columnName
                        }
                    })
                    this.init()
                    this.$emit('getMapData',arr)
                } else {
                    this.$message.error("获取失败！");
                }
            });
        },
        init() {
            var self = this;
            self.chart = echarts.init(this.$refs.myEchart);
            self.chart.on("click");
            self.chart.setOption({
                tooltip: {
                    trigger: "item",
                    formatter(params) {
                        return params.name
                    }
                },
                series: {
                    type: "pie",
                    radius: ["20%", "31%"],
                    center: ["45%", "60%"],
                    startAngle:90,
                    hoverAnimation: false ,
                    data: this.data,
                    itemStyle: {
                        color:'transparent',
                    },
                    label: {
                        position: "outer",
                        alignTo: "none",
                        bleedMargin: 5,
                        textStyle: { // 标签的字体样式
                            fontSize: 14,
                            color:'#666',
                            lineHeight:30
                        },
                        padding:[0,0,0,6],
                        formatter(params){
                            return params.dataIndex<9 ? "{icon|} " + self.characterEllipsis(params.name) : self.characterEllipsis(params.name) + " {icon|}"
                        },
                        // name:name + "  {icon|}",
                        rich: {
                            icon: {
                                width: 8,
                                height: 8,
                                align: 'left',
                                borderWidth:1,
                                borderColor:'#EA8780',
                                borderSyle:'sold',
                                borderRadius: 4,
                            }
                        },
                        emphasis:{fontWeight:'bold'},
                    },
                    labelLine: {
                        normal: {
                            length: 80, //第一条线
                            length2: 30, //第二条线
                            // maxSurfaceAngle: 0,
                            lineStyle: {
                                width: 1, // 线条的宽度
                                color: "#FFD2D1", //线的颜色设置， 如没有设置颜色则线条的颜色跟随饼状图的颜色
                                type: "dotted",
                            },
                        },
                    },
                    left: 0,
                    right: "0",
                    top: 0,
                    bottom: 0,
                },
            });
            self.chart.on('click', function(params) {
                self.$emit('changeMapActiveName',params.dataIndex,params.data.name)
            })
        },
        characterEllipsis(str) {
            if (str.length < 12) {
                return str;
            }
            return str.substr(0, 4) + "..."
        },
    },
  };
  </script>
  <style lang="scss" scoped>
  .graph-container{
    display: flex;
       .graph-cont-left {
           background: #f00;
            width: 640px;
            height:478px;
            position: relative;
            background: url("../assets/images/graph_bg.png") no-repeat -32px center;
              .center {
                  position: absolute;
                  width: 155px;
                  height: 147px;
                  background: url("../assets/images/graph_center.png") no-repeat;
                  top: 30%;
                  left: 32%;
                  z-index: 10;
                }

       }
   }
    </style>
